export default [
	{
		type: "special",
		id: 1,
		items: [
			{
				id: 1,
				text: "Course of studies",
				label: [
					{
						id: 1,
						text: "Mechatronics",
					},
					{
						id: 2,
						text: "Systems Engineering",
					},
					{
						id: 3,
						text: "Quantum Engineering",
					},
					{
						id: 4,
						text: "MWWT",
					},
					{
						id: 5,
						text: "MuN",
					},
					{
						id: 6,
						text: "CuK/Embedded Systems",
					},
					{
						id: 7,
						text: "LA Technik",
					},
					{
						id: 8,
						text: "Computer Science",
					},
					{
						id: 9,
						text: "Other",
					},
				],
			},
		],
	},
	{
		type: "text",
		id: 2,
		items: [
			{
				id: 2,
				type: "medium",
				text: "There was a scheduling collision with:",
			},
		],
	},
	{
		type: "uni",
		id: 3,
		items: [
			{
				id: 3,
				text: "The lab course is a useful supplement to the lecture.",
			},
			{
				id: 4,
				text: "The lab course reinforces the subject-speciﬁc material.",
			},
			{
				id: 5,
				text: "The lab course is well integrated into the course of study",
			},
			{
				id: 6,
				text: "The lab course teaches the practical application of the theory.",
			},
			{
				id: 7,
				text: "The lab course deepened my interest in the subject.",
			},
		],
	},
	{
		type: "bi",
		id: 4,
		items: [
			{
				id: 8,
				text: "The difficulty of the content was...",
			},
			{
				id: 9,
				text: "The amount of the content was...",
			},
			{
				id: 10,
				text: "The amount of time required for the course (including preparation and follow-up) was...",
			},
		],
	},
	{
		type: "text",
		id: 5,
		items: [{ id: 11, type: "small", text: "Average time spent on the lab (including preparation and follow-up) in hours per week:" }],
	},
	{
		type: "uni",
		id: 6,
		items: [
			{
				id: 12,
				text: "The grading criteria in the course were well deﬁned from the beginning.",
			},
			{
				id: 13,
				text: "The grading criteria are transparent.",
			},
			{
				id: 14,
				text: "The grading criteria are appropriate.",
			},
			{
				id: 15,
				text: "The supervisors are able to impart the content well.",
			},
			{
				id: 16,
				text: "The supervisors are well prepared.",
			},
			{
				id: 17,
				text: "The supervisors inspire me for the topic.",
			},
			{
				id: 18,
				text: "The rooms for the lab course are adequate.",
			},
			{
				id: 19,
				text: "There is sufficient availability of equipment.",
			},
			{
				id: 20,
				text: "The equipment is in perfect working order.",
			},
			{
				id: 21,
				text: "The equipment seems up-to-date.",
			},
			{
				id: 22,
				text: "There was ample opportunity for interaction with the lecturer through the online tools.",
			},
			{
				id: 23,
				text: "There was ample opportunity for interaction with the other students through the online tools.",
			},
			{
				id: 24,
				text: "The online appointments were well organized.",
			},
			{
				id: 25,
				text: "The online materials (e.g. texts, quizzes, videos, etc.) contributed significantly to the understanding of the learning content.",
			},
			{
				id: 26,
				text: "The possibilities of digital teaching beyond traditional teaching (discussion forums, interactive assignments, etc.) were well used.",
			},
			{
				id: 27,
				text: "Overall, the digital elements of the event were good.",
			},
			{
				id: 28,
				text: "The course is an example of good digital education.",
			},
		],
	},
	{
		type: "special",
		id: 7,
		items: [
			{
				id: 29,
				text: "Overall I evaluate the course with the grade",
				label: [
					{
						id: 1,
						text: "A",
					},
					{
						id: 2,
						text: "B",
					},
					{
						id: 3,
						text: "C",
					},
					{
						id: 4,
						text: "D",
					},
					{
						id: 5,
						text: "E",
					},
				],
			},
		],
	},
	{
		type: "text",
		id: 8,
		items: [
			{
				id: 30,
				text: "What was good about the lab, what should definitely stay?",
			},
			{
				id: 31,
				text: "What was bad about the lab, what should deﬁnitely be changed?",
			},
		],
	},
];
